import React, { useState } from "react";
import { Col, FormGroup, Input, Label, Row } from "reactstrap";
import { useApi } from "../../hooks/useApi";
import { toast } from "react-toastify";

const ContactTwo = () => {
  const defaultValues = {
    name: "",
    surname: "",
    email: "",
    message: "",
  };
  const [values, setValues] = useState(defaultValues);
  const handleValueChange = (e) => {
    setValues((value) => ({
      ...value,
      [e.target.name]: e.target.value,
    }));
  };
  const validationControl = () => {
    let isValid = true;
    const inputs = document.querySelectorAll(".form-input");
    inputs.forEach((input) => {
      input.classList.remove("is-invalid");
      if (input.type === "checkbox") {
        if (!input.checked) {
          isValid = false;
          input.classList.add("is-invalid");
        }
      }
      if (input.value === "") {
        isValid = false;

        input.classList.add("is-invalid");
      }
    });

    return isValid;
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = validationControl();
    if (!valid) return false;
    const formData = new FormData();
    for (const key in values) {
      formData.append(key, values[key]);
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useApi()
      .post("website/contactform", formData)
      .then((res) => {
        if (res.data.status) {
          toast.success("İletişim isteğiniz başarıyla alınmıştır.", {
            position: "top-center",
          });
          setValues(defaultValues);
        } else {
          toast.error("İletişim formu şu anda alınamıyor.");
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("İletişim formu şu anda alınamıyor.");
      });
  };
  return (
    <Row className="mt10 flex-column align-items-center ">
      <Col md={6}>
        <h4 className="contact-title-big text-center">Hadi konuşalım</h4>
        <p className="contact-text text-center">
          Bize bir şey sorun ya da merhaba deyin
        </p>
      </Col>
      <Col md={8} className=" mt-lg-0 mt-3">
        <Row tag={"form"} onSubmit={handleSubmit}>
          <Col md="5">
            <FormGroup floating>
              <Input
                className="form-input"
                id="name"
                name="name"
                placeholder="İsim"
                type="text"
                onChange={(e) => handleValueChange(e)}
              />
              <Label for="name">İsim</Label>
            </FormGroup>
          </Col>
          <Col md="6" className="offset-lg-1 ">
            <FormGroup floating>
              <Input
                className="form-input"
                id="surname"
                name="surname"
                placeholder="Soy isim"
                type="text"
                onChange={(e) => handleValueChange(e)}
              />
              <Label for="surname"> Soy isim</Label>
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup floating>
              <Input
                className="form-input"
                id="email"
                name="email"
                placeholder="Email"
                type="email"
                onChange={(e) => handleValueChange(e)}
              />
              <Label for="email">Email</Label>
            </FormGroup>
          </Col>
          <Col md="12" className="mt-4">
            <FormGroup floating>
              <Input
                className="form-input"
                id="mesaj"
                name="message"
                placeholder="Mesajınız"
                type="textarea"
                onChange={(e) => handleValueChange(e)}
              />
              <Label for="mesaj">Mesajınız</Label>
            </FormGroup>
          </Col>
          <Col md="12" className="d-flex justify-content-center mt-5">
            <button
              type="submit"
              className="btn btn-lg btn-white  btn-darkblue"
            >
              <div className="d-flex gap-2 align-items-center">
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="31"
                    viewBox="0 0 32 31"
                    fill="none"
                  >
                    <circle
                      cx="16.0005"
                      cy="15.1021"
                      r="15.1021"
                      fill="#3C3744"
                    />
                    <path
                      d="M17.4969 19.9973C17.3497 19.9973 17.2026 19.9431 17.0864 19.8269C16.8618 19.6023 16.8618 19.2306 17.0864 19.006L21.3769 14.7155L17.0864 10.4249C16.8618 10.2003 16.8618 9.82859 17.0864 9.60399C17.311 9.3794 17.6828 9.3794 17.9073 9.60399L22.6083 14.305C22.8329 14.5296 22.8329 14.9013 22.6083 15.1259L17.9073 19.8269C17.7912 19.9431 17.644 19.9973 17.4969 19.9973Z"
                      fill="white"
                    />
                    <path
                      d="M22.0643 15.2965H9.03007C8.71254 15.2965 8.44922 15.0331 8.44922 14.7156C8.44922 14.3981 8.71254 14.1348 9.03007 14.1348H22.0643C22.3818 14.1348 22.6451 14.3981 22.6451 14.7156C22.6451 15.0331 22.3818 15.2965 22.0643 15.2965Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <p className="mb-0">Gönder</p>
              </div>
            </button>
          </Col>
        </Row>
        <div className="d-flex   justify-content-center align-items-center mt-5">
          <div className="d-flex align-items-center flex-lg-row flex-column gap-4">
            <a
              href="mailto:info@eduvery.com"
              className="d-flex gap-1 align-items-center "
              target="_rasim"
              rel="noreferrer"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M2 12.7314C2 8.96021 2 7.07459 3.17157 5.90302C4.34315 4.73145 6.22876 4.73145 10 4.73145H14C17.7712 4.73145 19.6569 4.73145 20.8284 5.90302C22 7.07459 22 8.96021 22 12.7314C22 16.5027 22 18.3883 20.8284 19.5599C19.6569 20.7314 17.7712 20.7314 14 20.7314H10C6.22876 20.7314 4.34315 20.7314 3.17157 19.5599C2 18.3883 2 16.5027 2 12.7314Z"
                    stroke="white"
                    strokeWidth="1.5"
                  />
                  <path
                    d="M6 8.73145L8.1589 10.5305C9.99553 12.0611 10.9139 12.8263 12 12.8263C13.0861 12.8263 14.0045 12.0611 15.8411 10.5305L18 8.73145"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              info@eduvery.com
            </a>
            <a
              href="tel:05418288864"
              className="d-flex gap-1 align-items-center "
              target="_rasim"
              rel="noreferrer"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M10.0376 6.04762L10.6866 7.21055C11.2723 8.26003 11.0372 9.63677 10.1147 10.5592C10.1147 10.5592 10.1147 10.5592 10.1147 10.5592C10.1146 10.5594 8.99588 11.6783 11.0245 13.7069C13.0525 15.7349 14.1714 14.6175 14.1722 14.6167C14.1722 14.6167 14.1722 14.6167 14.1722 14.6167C15.0947 13.6943 16.4714 13.4591 17.5209 14.0448L18.6838 14.6939C20.2686 15.5783 20.4557 17.8007 19.0628 19.1936C18.2258 20.0306 17.2004 20.6819 16.0669 20.7249C14.1588 20.7972 10.9183 20.3143 7.6677 17.0637C4.41713 13.8132 3.93421 10.5727 4.00655 8.66453C4.04952 7.53105 4.7008 6.50568 5.53781 5.66868C6.93076 4.27573 9.15317 4.46288 10.0376 6.04762Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              0541 828 88 64
            </a>
            <a
              href="tel:05365630666"
              className="d-flex gap-1 align-items-center "
              target="_rasim"
              rel="noreferrer"
            >
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M10.0376 6.04762L10.6866 7.21055C11.2723 8.26003 11.0372 9.63677 10.1147 10.5592C10.1147 10.5592 10.1147 10.5592 10.1147 10.5592C10.1146 10.5594 8.99588 11.6783 11.0245 13.7069C13.0525 15.7349 14.1714 14.6175 14.1722 14.6167C14.1722 14.6167 14.1722 14.6167 14.1722 14.6167C15.0947 13.6943 16.4714 13.4591 17.5209 14.0448L18.6838 14.6939C20.2686 15.5783 20.4557 17.8007 19.0628 19.1936C18.2258 20.0306 17.2004 20.6819 16.0669 20.7249C14.1588 20.7972 10.9183 20.3143 7.6677 17.0637C4.41713 13.8132 3.93421 10.5727 4.00655 8.66453C4.04952 7.53105 4.7008 6.50568 5.53781 5.66868C6.93076 4.27573 9.15317 4.46288 10.0376 6.04762Z"
                    stroke="white"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              0536 563 06 66
            </a>
            <a href="https://www.instagram.com/eduveryy/" target="_blank" rel="noreferrer">
            <span className="me-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="23"
              viewBox="0 0 22 23"
              fill="none"
            >
              <g clipPath="url(#clip0_265_1745)">
                <path
                  d="M11 2.7123C13.9391 2.7123 14.2871 2.7252 15.443 2.77676C16.5172 2.82402 17.0973 3.00449 17.484 3.15488C17.9953 3.35254 18.3648 3.59316 18.7473 3.97559C19.134 4.3623 19.3703 4.72754 19.568 5.23887C19.7184 5.62559 19.8988 6.20996 19.9461 7.27988C19.9977 8.44004 20.0105 8.78809 20.0105 11.7229C20.0105 14.6619 19.9977 15.01 19.9461 16.1658C19.8988 17.24 19.7184 17.8201 19.568 18.2068C19.3703 18.7182 19.1297 19.0877 18.7473 19.4701C18.3605 19.8568 17.9953 20.0932 17.484 20.2908C17.0973 20.4412 16.5129 20.6217 15.443 20.6689C14.2828 20.7205 13.9348 20.7334 11 20.7334C8.06094 20.7334 7.71289 20.7205 6.55703 20.6689C5.48281 20.6217 4.90273 20.4412 4.51602 20.2908C4.00469 20.0932 3.63516 19.8525 3.25273 19.4701C2.86602 19.0834 2.62969 18.7182 2.43203 18.2068C2.28164 17.8201 2.10117 17.2357 2.05391 16.1658C2.00234 15.0057 1.98945 14.6576 1.98945 11.7229C1.98945 8.78379 2.00234 8.43574 2.05391 7.27988C2.10117 6.20566 2.28164 5.62559 2.43203 5.23887C2.62969 4.72754 2.87031 4.35801 3.25273 3.97559C3.63945 3.58887 4.00469 3.35254 4.51602 3.15488C4.90273 3.00449 5.48711 2.82402 6.55703 2.77676C7.71289 2.7252 8.06094 2.7123 11 2.7123ZM11 0.731445C8.01367 0.731445 7.63984 0.744336 6.4668 0.795898C5.29805 0.847461 4.49453 1.03652 3.79844 1.30723C3.07227 1.59082 2.45781 1.96465 1.84766 2.5791C1.2332 3.18926 0.859375 3.80371 0.575781 4.52559C0.305078 5.22598 0.116016 6.0252 0.0644531 7.19395C0.0128906 8.37129 0 8.74512 0 11.7314C0 14.7178 0.0128906 15.0916 0.0644531 16.2646C0.116016 17.4334 0.305078 18.2369 0.575781 18.933C0.859375 19.6592 1.2332 20.2736 1.84766 20.8838C2.45781 21.4939 3.07227 21.8721 3.79414 22.1514C4.49453 22.4221 5.29375 22.6111 6.4625 22.6627C7.63555 22.7143 8.00937 22.7271 10.9957 22.7271C13.982 22.7271 14.3559 22.7143 15.5289 22.6627C16.6977 22.6111 17.5012 22.4221 18.1973 22.1514C18.9191 21.8721 19.5336 21.4939 20.1437 20.8838C20.7539 20.2736 21.132 19.6592 21.4113 18.9373C21.682 18.2369 21.8711 17.4377 21.9227 16.2689C21.9742 15.0959 21.9871 14.7221 21.9871 11.7357C21.9871 8.74942 21.9742 8.37559 21.9227 7.20254C21.8711 6.03379 21.682 5.23027 21.4113 4.53418C21.1406 3.80371 20.7668 3.18926 20.1523 2.5791C19.5422 1.96895 18.9277 1.59082 18.2059 1.31152C17.5055 1.04082 16.7062 0.851758 15.5375 0.800195C14.3602 0.744336 13.9863 0.731445 11 0.731445Z"
                  fill="white"
                />
                <path
                  d="M11.002 6.08105C7.88242 6.08105 5.35156 8.61191 5.35156 11.7314C5.35156 14.851 7.88242 17.3818 11.002 17.3818C14.1215 17.3818 16.6523 14.851 16.6523 11.7314C16.6523 8.61191 14.1215 6.08105 11.002 6.08105ZM11.002 15.3967C8.97813 15.3967 7.33672 13.7553 7.33672 11.7314C7.33672 9.70762 8.97813 8.06621 11.002 8.06621C13.0258 8.06621 14.6672 9.70762 14.6672 11.7314C14.6672 13.7553 13.0258 15.3967 11.002 15.3967Z"
                  fill="white"
                />
                <path
                  d="M18.193 5.85723C18.193 6.5877 17.6 7.17637 16.8738 7.17637C16.1434 7.17637 15.5547 6.5834 15.5547 5.85723C15.5547 5.12676 16.1477 4.53809 16.8738 4.53809C17.6 4.53809 18.193 5.13106 18.193 5.85723Z"
                  fill="white"
                />
              </g>
              <defs>
                <clipPath id="clip0_265_1745">
                  <rect
                    width="22"
                    height="22"
                    fill="white"
                    transform="translate(0 0.731445)"
                  />
                </clipPath>
              </defs>
            </svg>
            </span>
            Instagram
          </a>
          </div>
          <div className="d-flex gap-3 align-items-center">
            
            
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default ContactTwo;
